import React from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface KPICardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  description?: string;
  trend?: 'up' | 'down' | 'neutral';
  color?: 'blue' | 'green' | 'red' | 'yellow';
  subtitle?: string;
  progressValue?: number; // Nuovo: valore percentuale per la barra (0-100)
}

export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  icon: Icon,
  description,
  trend,
  color = 'blue',
  subtitle,
  progressValue
}) => {
  const colorClasses = {
    blue: 'text-blue-400 bg-blue-400/10',
    green: 'text-green-400 bg-green-400/10',
    red: 'text-red-400 bg-red-400/10',
    yellow: 'text-yellow-400 bg-yellow-400/10'
  };

  const trendColors = {
    up: 'text-green-400',
    down: 'text-red-400',
    neutral: 'text-gray-400'
  };

  return (
    <div className="bg-gray-800/50 backdrop-blur-sm border border-gray-700 rounded-lg p-4 sm:p-6 hover:bg-gray-800/70 transition-all duration-200 group">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-2 sm:space-x-3 mb-2 sm:mb-3">
            <div className={`p-1.5 sm:p-2 rounded-lg ${colorClasses[color]}`}>
              <Icon className="h-3 w-3 sm:h-5 sm:w-5" />
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-gray-400 uppercase tracking-wide">
                {title}
              </p>
            </div>
          </div>
          
          <div className="mb-2">
            <p className="text-xl sm:text-2xl font-bold text-white">{value}</p>
            {subtitle && (
              <p className="text-xs sm:text-sm text-gray-400 mt-1">{subtitle}</p>
            )}
          </div>
          
          {description && (
            <p className="text-xs text-gray-500 hidden sm:block">{description}</p>
          )}
        </div>
        
        {trend && (
          <div className={`text-xs ${trendColors[trend]} font-medium`}>
            {trend === 'up' ? '↗' : trend === 'down' ? '↘' : '→'}
          </div>
        )}
      </div>
      
      {/* Barra di progresso - mostrata solo se progressValue è fornito */}
      {progressValue !== undefined && (
        <div className="mt-3 sm:mt-4 h-2 bg-gray-700 rounded-full overflow-hidden">
          <div 
            className={`h-full ${color === 'red' ? 'bg-red-400' : color === 'green' ? 'bg-green-400' : color === 'yellow' ? 'bg-yellow-400' : 'bg-blue-400'} rounded-full transition-all duration-1000`}
            style={{ width: `${Math.min(Math.max(progressValue, 0), 100)}%` }}
          />
        </div>
      )}
    </div>
  );
};